import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { startsWith } from 'ramda';
import qs from 'query-string';
import moment from 'moment';

import env from '../env';

function getCookie(name) {
  return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
}

function getAuthHeader() {
  return `${window.localStorage.getItem('token')}`;
}

function createAxios(auth) {

  const headers = {};

  if (auth) {
    headers['Authorization'] = getAuthHeader();
    headers['X-Client'] = 'da';
  }
  // headers['Accept-Encoding']='gzip';

  return axios.create({
    baseURL: `${env.urls.podHost}/`,
    withCredentials: true,
    headers,
    paramsSerializer: qs.stringify,
  });
}

function requestInterceptor(config) {
  const token = window.localStorage.getItem('token');

  // TODO: need a better way to handle token refresh
  if (startsWith('/login', window.location.pathname)) {
    return config;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    return config;
  }
  // Token has expired
  if (moment.unix(decoded.exp) < (moment().add(5, 'seconds'))) {
    return new Promise((resolve) => {
      // createAxios().post('auth/refresh_token/')
      //   .then(({data}) => {  // Token refresh successful
      //     window.localStorage.setItem('token', data.token);
      //     config.headers.Authorization = getAuthHeader();
      //     resolve(config);
      //   })
      //   .catch(err => {  // Session expired; user needs to login again
      //     window.location = '/login';
      //   });
     clearLocalStorage();
    });
  }
  return config;
};

export default (auth = true) => {
  const instance = createAxios(auth);
  if (auth) {
   //Intercepting Request
   instance.interceptors.request.use(requestInterceptor);

   //Intercepting Response
   instance.interceptors.response.use((response) => {
     return response;
   }, (err) => {
     if (err.response.status === 401)
       clearLocalStorage();
       return Promise.reject(err);
   });
  }
  return instance;
};

const clearLocalStorage = () => {
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('user');

  alert('Session Expired! Please login again');
  window.location.href = '/';
}
